import { render } from "./TestResultDetailView.vue?vue&type=template&id=9fbc8ce0&scoped=true"
import script from "./TestResultDetailView.vue?vue&type=script&lang=js"
export * from "./TestResultDetailView.vue?vue&type=script&lang=js"

import "./TestResultDetailView.vue?vue&type=style&index=0&id=9fbc8ce0&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fbc8ce0"]])

export default __exports__